import BackBtn from '../../Buttons/BackBtn/BackBtn';
import ContinueBtn from '../../Buttons/ContinueBtn/ContinueBtn';
import './CartMain.css';
import { Link } from 'react-router-dom';
import CartListTemplate from '../CartListTemplate/CartListTemplate';
import Total from '../../Inputs/Total/Total';



const CartMain = () => {
    return ( 
        <div className="cartmain">
            <div className="cartmaincontent">
                <CartListTemplate />
            </div>

            <div className="cartmaintotal">
                <Total />
            </div>

            <div className="cartmainbtns">
                <Link to="/select"><BackBtn /></Link>
                <Link to="#checkout" onClick={event =>  window.location.href='#checkout'}><ContinueBtn /></Link>
            </div>
        </div>
     );
}
 
export default CartMain;